module.exports = __webpack_public_path__ + "img/70.1622f32e.png";